import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

const groupLevelSortOptions = [
  { value: 'name', label: 'Group Name' },
  { value: 'totalHours', label: 'Total Hours' },
  { value: 'totalEstimated', label: 'Total Estimated' },
  { value: 'uniqueIssues', label: 'Unique Issues' },
  { value: 'totalEntries', label: 'Total Entries' },
  { value: 'efficiency', label: 'Efficiency' },
  { value: 'variance', label: 'Variance' },
  { value: 'earliestDate', label: 'Earliest Date' },
  { value: 'latestDate', label: 'Latest Date' },
];

const withinGroupSortOptions = [
  { value: 'loggedDate', label: 'Date' },
  { value: 'loggedHours', label: 'Hours' },
  { value: 'issue_key', label: 'Issue Key' },
  { value: 'author', label: 'Author' },
  { value: 'issue_assignee', label: 'Assignee' },
  { value: 'variance', label: 'Variance' },
  { value: 'started', label: 'Start Time' },
];

const SortingControls = ({ sorting, onSortingChange, grouping }) => {
  const handleGroupLevelFieldChange = (field) => {
    onSortingChange({
      ...sorting,
      groupLevel: {
        ...sorting.groupLevel,
        field,
      },
    });
  };

  const handleGroupLevelDirectionToggle = () => {
    onSortingChange({
      ...sorting,
      groupLevel: {
        ...sorting.groupLevel,
        direction: sorting.groupLevel.direction === 'asc' ? 'desc' : 'asc',
      },
    });
  };

  const handleWithinGroupFieldChange = (field) => {
    onSortingChange({
      ...sorting,
      withinGroup: {
        ...sorting.withinGroup,
        field,
      },
    });
  };

  const handleWithinGroupDirectionToggle = () => {
    onSortingChange({
      ...sorting,
      withinGroup: {
        ...sorting.withinGroup,
        direction: sorting.withinGroup.direction === 'asc' ? 'desc' : 'asc',
      },
    });
  };

  return (
    <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3 min-w-0">
      {grouping.field !== 'none' && (
        <div className="flex items-center space-x-2 min-w-0 flex-shrink">
          <label className="text-xs font-medium text-gray-600 dark:text-slate-400 whitespace-nowrap flex-shrink-0">Sort Groups:</label>
          <select
            value={sorting.groupLevel.field}
            onChange={(e) => handleGroupLevelFieldChange(e.target.value)}
            className="px-2 py-1.5 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-xs bg-white dark:bg-slate-900 border-gray-300 dark:border-white/20 text-gray-900 dark:text-slate-100 min-w-0 flex-shrink"
          >
            {groupLevelSortOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <button
            onClick={handleGroupLevelDirectionToggle}
            className="p-1.5 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 border-gray-300 dark:border-white/20 hover:bg-gray-50 dark:hover:bg-slate-700"
            title={`Sort ${sorting.groupLevel.direction === 'asc' ? 'Ascending' : 'Descending'}`}
          >
            {sorting.groupLevel.direction === 'asc' ? (
              <ArrowUp className="w-3.5 h-3.5 text-gray-600 dark:text-slate-200" />
            ) : (
              <ArrowDown className="w-3.5 h-3.5 text-gray-600 dark:text-slate-200" />
            )}
          </button>
        </div>
      )}

      <div className="flex items-center space-x-2 min-w-0 flex-shrink">
        <label className="text-xs font-medium text-gray-600 dark:text-slate-400 whitespace-nowrap flex-shrink-0">
          {grouping.field !== 'none' ? 'Sort Items:' : 'Sort:'}
        </label>
        <select
          value={sorting.withinGroup.field}
          onChange={(e) => handleWithinGroupFieldChange(e.target.value)}
          className="px-2 py-1.5 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-xs bg-white dark:bg-slate-900 border-gray-300 dark:border-white/20 text-gray-900 dark:text-slate-100 min-w-0 flex-shrink"
        >
          {withinGroupSortOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <button
          onClick={handleWithinGroupDirectionToggle}
          className="p-1.5 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 border-gray-300 dark:border-white/20 hover:bg-gray-50 dark:hover:bg-slate-700"
          title={`Sort ${sorting.withinGroup.direction === 'asc' ? 'Ascending' : 'Descending'}`}
        >
          {sorting.withinGroup.direction === 'asc' ? (
            <ArrowUp className="w-3.5 h-3.5 text-gray-600 dark:text-slate-200" />
          ) : (
            <ArrowDown className="w-3.5 h-3.5 text-gray-600 dark:text-slate-200" />
          )}
        </button>
      </div>
    </div>
  );
};

export default SortingControls;

